import React, { useState } from 'react';
import '../dropdown/News.css';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaChevronRight } from 'react-icons/fa';
import evitara from '../assets/evitara.png';
import kushaq from '../assets/skodakushaq.png';
import gravite from '../assets/gravite.png';
import modely from '../assets/teslamodely.png';
import cityHybrid from '../assets/cityhybrid.png';
import sierraEV from '../assets/sierraev.png';
import xuve8 from '../assets/xuve8.png';
import virtusGT from '../assets/virtusgt.png';
import Pagination from './Pagination';
import SidebarExpertReviews from './SidebarExpertReviews';
import SidebarElectricVehicles from './SidebarElectricVehicles';

const News = () => {
  const newsItems = [
  {
    id: 1,
    category: "Electric",
    title: "Maruti e Vitara Officially Revealed for India",
    price: "₹18 Lakh (Expected)",
    description: "Maruti Suzuki showcased the production-ready e Vitara with dual-screen interiors, ADAS features, and two battery pack options ahead of its India launch.",
    image: evitara,
    link: "https://www.marutisuzuki.com/e-vitara",
    date: "April 04, 2026"
  },
  {
    id: 2,
    category: "SUV",
    title: "Skoda Kushaq 2026 Facelift Debuts",
    price: "₹11.20 Lakh onwards",
    description: "Skoda launched the refreshed Kushaq with updated styling, new connected-car features, and improved cabin quality for the 2026 lineup.",
    image: kushaq,
    link: "https://www.skoda-auto.co.in/models/kushaq/kushaq",
    date: "April 11, 2026"
  },
  {
    id: 3,
    category: "MPV",
    title: "Nissan Gravite CNG Variant Introduced",
    price: "₹7.80 Lakh onwards",
    description: "Nissan expanded the Gravite lineup with a dealer-level CNG retrofit option, improving fuel efficiency and reducing running costs for urban buyers.",
    image: gravite,
    link: "https://www.nissan.in/",
    date: "April 18, 2026"
  },
  {
    id: 4,
    category: "Luxury EV",
    title: "Tesla Model Y L Begins India Deliveries",
    price: "₹64.90 Lakh (Expected)",
    description: "Tesla started deliveries of the long-wheelbase Model Y L in India, offering a 6-seat layout, enhanced rear comfort, and upgraded range.",
    image: modely,
    link: "https://www.tesla.com/en_in/modely",
    date: "April 26, 2026"
  },
  {
    id: 5,
    category: "Hybrid",
    title: "Honda City Hybrid 2026 Updated with New Tech",
    price: "₹19.20 Lakh onwards",
    description: "Honda refreshed the City Hybrid with a larger infotainment display, improved ADAS suite, and enhanced cabin comfort features for 2026.",
    image: cityHybrid,
    link: "https://www.hondacarindia.com/",
    date: "April 08, 2026"
  },
  {
    id: 6,
    category: "Electric",
    title: "Tata Sierra EV Testing Nears Production Stage",
    price: "₹25 Lakh (Expected)",
    description: "The upcoming Tata Sierra EV has entered final testing phases with a futuristic cabin, panoramic glass roof, and expected 500km+ driving range.",
    image: sierraEV,
    link: "https://ev.tatamotors.com/",
    date: "April 14, 2026"
  },
  {
    id: 7,
    category: "SUV",
    title: "Mahindra XUV.e8 Interior Officially Revealed",
    price: "₹30 Lakh (Expected)",
    description: "Mahindra showcased the production-spec cabin of the XUV.e8 featuring triple-screen layout, ambient lighting, and Level 2 ADAS technology.",
    image: xuve8,
    link: "https://www.mahindraelectric.com/",
    date: "April 20, 2026"
  },
  {
    id: 8,
    category: "Premium Sedan",
    title: "Volkswagen Virtus GT Line Gets New Features",
    price: "₹17.50 Lakh onwards",
    description: "Volkswagen updated the Virtus GT Line with a new digital cockpit, enhanced connected-car tech, and cosmetic tweaks for the 2026 model year.",
    image: virtusGT,
    link: "https://www.volkswagen.co.in/",
    date: "April 29, 2026"
  }
];
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = newsItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(newsItems.length / itemsPerPage);

  return (
    <div className="news-page-container">
      <div className="news-hero-banner">
        <div className="news-hero-content">
          <span className="hero-eyebrow">CarsChalao Exclusive</span>
          <h1>Automotive Intelligence</h1>
          <p>Real-time updates from the heart of the Indian car market.</p>
        </div>
      </div>

      <div className="news-content-layout">
        <main className="news-main-feed">
          <div className="news-grid">
            {currentItems.map((item) => (
              <article className="news-card-modern" key={item.id}>
                <div className="news-image-box">
                  <span className="category-tag">{item.category}</span>
                  <img src={item.image} alt={item.title} />
                  <div className="image-overlay"></div>
                </div>
                
                <div className="news-info-box">
                  <div className="news-meta-top">
                    
                    <span className="news-price-tag">{item.price}</span>
                  </div>
                  <h3 className="news-card-title">{item.title}</h3>
                  <p className="news-card-desc">{item.description}</p>
                  
                  <div className="news-card-footer">
                    <a href={item.link} className="news-read-btn">
                      Full Story <FaChevronRight size={10} />
                    </a>
                    <div className="news-share-group">
                      <FaFacebookF className="share-icon" />
                      <FaTwitter className="share-icon" />
                      <FaLinkedinIn className="share-icon" />
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="news-pagination-section">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </main>

        <aside className="news-sidebar">
          <SidebarExpertReviews />
          <SidebarElectricVehicles />
        </aside>
      </div>
    </div>
  );
};

export default News;